export default {
  id: 'NoPermissionPage',
  code: 'CN',
  text: {
    'Oops!': '啊哦！',
    'You do not have the permission to visit this page, please contact the school principal for permission': '您没有权限访问此页面，请与学校校长联系以获得权限',

  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/NoPermission/locale.js